import React, { useEffect, useRef } from 'react';
import { usePageSplitClasses } from '../hooks';
export const PageSplitPanelResizable = ({ children, size, setSize, className: optionalClassName, type, }) => {
    const refObject = useRef(null);
    const { panelResizable } = usePageSplitClasses(optionalClassName, type);
    useEffect(() => {
        if (refObject.current) {
            if (type === 'vertical-divider') {
                if (!size) {
                    setSize(refObject.current.clientWidth);
                    return;
                }
                refObject.current.style.width = `${size}px`;
            }
            if (type === 'horizontal-divider') {
                if (!size) {
                    setSize(refObject.current.clientHeight);
                    return;
                }
                refObject.current.style.height = `${size}px`;
            }
        }
    }, [refObject, size, setSize, type]);
    return (React.createElement("div", { "data-testid": "PageSplitPanelResizable", className: panelResizable, ref: refObject }, children));
};
//# sourceMappingURL=PageSplitPanelResizable.js.map